export default {"src":"/_next/static/media/reddit.e01dccf6.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};